import { gql } from '@apollo/client';

export const PUBLISH_CASE_FORM = gql`
    mutation publishCaseForm($id: ID!) {
        publishCaseForm(id: $id) {
            ok
        }
    }
`;
